import { Skeleton, Stack, Group, Container } from '@mantine/core';
import React from 'react';

const LoaderCoursePlanDetail = () => {
  return (
    <Container fluid>
      <Stack gap={24}>
        <Group justify='space-between'>
          <Group>
            <Skeleton height={32} width={300} />
            <Skeleton height={24} width={80} />
            <Skeleton height={24} width={100} />
          </Group>
          <Skeleton height={32} width={32} />
        </Group>

        <Group align='flex-start'>
          <Stack flex={1} gap={20}>
            <Skeleton height={60} />
            <Skeleton height={200} />
            <Skeleton height={150} />
          </Stack>
          <Stack w={412} gap={20}>
            <Skeleton height={120} />
            <Skeleton height={180} />
            <Skeleton height={100} />
          </Stack>
        </Group>
      </Stack>
    </Container>
  );
};

export default LoaderCoursePlanDetail;
